document.addEventListener("DOMContentLoaded", () => {
  const header = document.getElementById("main-header");
  const category = document.getElementById("category-header");
  const topbar = document.getElementById("shopify-section-announcement-bar");
  const searchDetails = document.querySelector("details");

  if (!header) return;

  const headerInitialOffset = header.offsetTop;
  let lastScrollY = window.scrollY;
  let ticking = false;
  let keepVisible = false;

  header.querySelectorAll("summary").forEach(summary => {
    summary.addEventListener("click", () => {
      keepVisible = true;
      header.classList.remove("hide");
    });
  });

  function onScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY > headerInitialOffset) {
      if (!header.classList.contains("stuck")) header.classList.add("stuck");

      if (!keepVisible) {
        if (currentScrollY > lastScrollY) {
          category?.classList.add("hide");
          topbar?.classList.add("topbar--hidden");
          header.classList.remove("fix");
        } else {
          category?.classList.remove("hide");
          topbar?.classList.remove("topbar--hidden");
          header.classList.add("fix");
        }
      }
    } else {
      header.classList.remove("stuck", "hide", "fix");
      category?.classList.remove("hide");
      topbar?.classList.remove("topbar--hidden");
      keepVisible = false;
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });

  if (window.scrollY > headerInitialOffset) {
    topbar?.classList.add("topbar--hidden");
    category?.classList.add("hide");
    header.classList.add("stuck");
  }

  if (searchDetails) {
    searchDetails.addEventListener('toggle', () => {
      if (!searchDetails.open) requestAnimationFrame(onScroll);
    });
  }
});
